import React, { useContext, useState } from "react";

import * as Icon from "react-feather";
import logo from "../../../assets/images/logo.svg";
import { H5, P } from "../../atoms/Texts";
import ProfileDropDown from "../../molecules/ProfileDropdown";

import { themeContext, demoContext } from "../../../shared/store/contexts";
import { DashboardHeaderStyle } from "./styles";
import { Link, useParams } from "react-router-dom";

export const DashboardHeader = ({ className, title }) => {
  const { theme } = useContext(themeContext);

  const { organization } = useContext(demoContext);
  const { id } = useParams();

  const [showDropDown, setShowDropDown] = useState(false);

  const toggleDropDown = () => setShowDropDown(!showDropDown);

  return (
    <DashboardHeaderStyle
      bg={theme.background}
      className="pl-6 pr-10 sticky inset-0 mx-auto py-2 md:py-4 flex justify-between items-center"
    >
      <div className="flex items-center">
        <Link to="/">
          <img src={logo} alt="" />
        </Link>
      </div>
      <div className="flex items-center">
        <div className="relative">
          {false && (
            <div
              className="absolute py-px px-2 bg-red-600 rounded-full border border-white"
              style={{
                top: "-10px",
                right: "14px",
              }}
            >
              <P color="#ffffff" fontSize="10px" smallSize="10px">
                2
              </P>
            </div>
          )}
        </div>
        <Link to={`/dashboard/organization/${id}/settings`}>
          <Icon.Settings size={18} color="#413E53" className="mr-6" />
        </Link>

        <div className="relative cursor-pointer">
          <div onClick={toggleDropDown} className="flex items-center">
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center object-cover"
              style={{ background: "#EAE7FE" }}
            >
              <H5 color="#12046D" className="capitalize">
                TB
              </H5>
            </div>
            <H5
              color={theme.primaryFont}
              fontSize="16px"
              className="capitalize mx-4"
            >
              Tara Blake
            </H5>
            <Icon.ChevronDown size={16} className="" color="#767E85" />
          </div>
          {showDropDown && (
            <ProfileDropDown org={organization} toggleDropDown={toggleDropDown} />
          )}
        </div>
      </div>
    </DashboardHeaderStyle>
  );
};
